export const PathsColumns = [
    {
        name: "Nome da Pasta",
        id: "pathName"
    },
];